/**
 * Reducer to control the snackbar status.
 */

import { AsyncAction } from '..';

type State = { [id: string]: Event };
type Event = { id: string; type: 'error' | 'info'; message: string; timeout: number };

type Action =
    | { type: 'global_event/create'; payload: Event }
    | { type: 'global_event/delete'; payload: { id: string } };

const initialState: State = {};

export const reducer = (state = initialState, action: Action): State => {
    switch (action.type) {
        case 'global_event/create': {
            return { ...state, [action.payload.id]: action.payload };
        }
        case 'global_event/delete': {
            delete state[action.payload.id];
            return { ...state };
        }
        default:
            return state;
    }
};

const create = (type: 'error' | 'info', message: string, timeout = 5): AsyncAction => async dispatch => {
    const id = Math.random().toString();
    dispatch({ type: 'global_event/create', payload: { id, type, message, timeout } });
    setTimeout(() => dispatch({ type: 'global_event/delete', payload: { id } }), (timeout + 1) * 1000);
};

export const creators = { create };
